import Button from "../../../../common/components/atom/Button/Button";
import HeaderWidget from "../../../../common/components/molecule/HeaderWidget/HeaderWidget";
import { useMicroNavigator } from "../../../../common/components/organisme/MicroNavigator/MicroNavigatorContext";
import { SinglePlanBT } from "../../../../features/planBT/components/PlanBT/SinglePlanBT";
import { PermissionTooltip, useCapability } from "../../../../features/rbac";


export default function PoleListPage() {
  const {navigate} =useMicroNavigator()
  const canEdit = useCapability('planbt.edit')
  return (
    <>
    <HeaderWidget  variant="dark">Poteaux Électiques</HeaderWidget>
    <PermissionTooltip allowed={canEdit}>
      <Button variant={"dark-parimary"} disabled={!canEdit} onClick={() => navigate('create')} iconRightType={"plus"}>Ajouter</Button>
    </PermissionTooltip>
    <SinglePlanBT.PoleList/>
    </>

  )
}
